<script setup lang="ts">
import Icon from '~/components/Icon/Legacy/index.vue'

interface Props {
  title: string
  description: string
  href: string
}

interface Emits {
  (e: 'click', event: MouseEvent): void
}

defineProps<Props>()
defineEmits<Emits>()

const { colors } = useTheme()
</script>

<template>
  <NuxtLink :to="href" w="full lg:1/2" bg="hover:gray-lighter" px="10px" py="15px" mx="-10px" rounded-lg @click="$emit('click', $event)">
    <div flex="~ items-center" gap-2>
      <Text variant="subtitle" :color="colors.black" center>
        {{ title }}
      </Text>
      <Icon name="arrow" w-3 />
    </div>

    <Text variant="caption">
      {{ description }}
    </Text>
  </NuxtLink>
</template>
